import React, { Component } from 'react'
import {Row, Col} from 'reactstrap'
import checkMarkSVG from '../../../assets/images/icons/checkmark.svg';
import PropTypes from "prop-types";

class LaminateField extends Component {
  renderLaminateTitle(key) {
    if (key === 'glossy') {
      return this.context.t('Glossy')
    } else if (key === 'matt'){
      return this.context.t('Matt')
    } else if (key === 'none'){
      return this.context.t('None')
    }
  }
  render() {
    const {
      input: { value, onChange },
      laminates,
      itemsClassName
    } = this.props

    const _itemsClassName = itemsClassName ? (' ' + itemsClassName) : '';
    return (
      <div>
        <Row>
          { laminates.map((availableLaminate, index) => {
            const isChecked = (availableLaminate.key === value);

            return (
              <Col
                key={index}
                xs={4}
                className={'laminate-field'}
                htmlFor={ availableLaminate.key }
                onClick={() => onChange(availableLaminate.key)}
              >
                <div
                  className={'laminate-field--icon-container' + _itemsClassName + (isChecked ? ' selected' : '')}
                >
                  <img
                    src={ availableLaminate.iconURL }
                    alt={availableLaminate.key}
                    className={ `laminate-field--icon laminate-ad-hoc--${availableLaminate.key}` }
                    loading="lazy"
                  />
                  { isChecked &&
                    <img
                      src={checkMarkSVG}
                      alt={'selected_option'}
                      className="laminate-field--checkmark"
                      loading="lazy"
                    />
                  }
                </div>
                <div className="laminate-field--title text-center">{ this.renderLaminateTitle(availableLaminate.key) }</div>

              </Col>
            );
          })}
        </Row>
        <p className="text-remark pt-3">{this.context.t('If you want to learn more about protective coating / lamination you should read the help section.')}</p>
      </div>
    )
  }
}

/**  define proptype for the 'translation' function  */
LaminateField.contextTypes = {
  t: PropTypes.func
}

export default LaminateField;